import businessIcon from "../../assets/new_profile/module-icons/profile-business-icon.svg";
import adminIcon from "../../assets/new_profile/module-icons/profile-admin-icon.svg";
import arIcon from "../../assets/new_profile/module-icons/profile-ar-icon.svg";
import educationIcon from "../../assets/new_profile/module-icons/profile-education-icon.svg";
import productIcon from "../../assets/new_profile/module-icons/profile-product-icon.svg";
import clientIcon from "../../assets/new_profile/module-icons/profile-client-icon.svg";
import ambitionIcon from "../../assets/new_profile/module-icons/profile-ambition-icon.svg";
import reportIcon from "../../assets/new_profile/module-icons/profile-report-icon.svg";
import shareIcon from "../../assets/new_profile/module-icons/profile-share-icon.svg";
import mapIcon from "../../assets/new_profile/module-icons/profile-map-icon.svg";
import feedIcon from "../../assets/new_profile/module-icons/profile-feed-icon.svg";
import simulateIcon from "../../assets/new_profile/module-icons/profile-simulate-icon.svg";
import getHelpIcon from "../../assets/new_profile/module-icons/profile-get-help-icon.svg";
import companyIcon from "../../assets/new_profile/module-icons/profile-company-icon.svg";
import erpIcon from "../../assets/new_profile/module-icons/erp-icon.svg";

export const getIconModule = (name) => {
  switch (name) {
    case "Company":
      return companyIcon;
    case "Admin":
      return adminIcon;
    case "AR":
      return arIcon;
    case "Education":
      return educationIcon;
    case "Product":
      return productIcon;
    case "Client":
      return clientIcon;
    case "Ambition":
      return ambitionIcon;
    case "Report":
      return reportIcon;
    case "Share":
      return shareIcon;
    case "Map":
      return mapIcon;
    case "Feed":
      return feedIcon;
    case "Simulate":
      return simulateIcon;
    case "Get Help":
      return getHelpIcon;
    case "Business":
      return businessIcon;
    case "ERP":
      return erpIcon;
    default:
      break;
  }
};

export const getColorModule = (name) => {
  switch (name) {
    case "Education":
      return "rgba(178, 147, 158, 0.85)";
    case "Product":
      return "rgba(215, 210, 214, 0.8)";
    case "Client":
      return "rgba(203, 161, 53, 0.8)";
    case "Ambition":
      return "rgba(172, 208, 206, 0.8)";
    case "Report":
      return "rgba(213, 200, 221, 0.85)";
    case "Share":
      return "rgba(193, 192, 141, 0.8)";
    case "Map":
      return "rgba(206, 71, 96, 0.8)";
    case "Feed":
      return "rgba(242, 138, 95, 0.8)";
    case "Simulate":
      return "rgba(255, 177, 0, 8)";
    case "Get Help":
      return "rgba(34, 54, 97, 0.8)";
    case "Company":
      return "rgba(139, 167, 154, 0.8)";
    default:
      return "rgba(36, 51, 97, 0.6)";
  }
};
